// ============================================================================
// LoginPage Wrapper
// Ensures i18n is initialized before rendering LoginPage
// ============================================================================

import { useEffect, useState } from 'react';
import { LoginPage } from '@gumahub/authentication';
import { i18nReady } from '../i18n';

export default function LoginPageWrapper() {
  const [isI18nReady, setIsI18nReady] = useState(false);

  useEffect(() => {
    // Wait for i18n to be ready using the promise
    i18nReady.then(() => {
      setIsI18nReady(true);
    }).catch((err) => {
      console.error('i18n initialization failed:', err);
      setIsI18nReady(true); // Force ready anyway
    });
  }, []);

  if (!isI18nReady) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Loading translations...</p>
        </div>
      </div>
    );
  }

  return <LoginPage />;
}
